import { rest } from 'msw'
import { Application } from 'types/customers'
import mockCustomers from '../../../__mocks__/Customers/customers.json'

const API_URL = process.env.API_URL

export const getCustomersHandler = rest.get(
  `${API_URL}/api/platform/v1/customers`,
  async (req, res, ctx) => {
    const page = Number.parseInt(req.url.searchParams.get('page') || '0', 10)
    const size = Number.parseInt(req.url.searchParams.get('size') || '20', 10)

    const totalElements = mockCustomers.length
    const totalPages = Math.ceil(totalElements / size)
    const startIndex = page * size
    const endIndex = startIndex + size
    const paginatedContent = mockCustomers.slice(startIndex, endIndex)

    return res(
      ctx.json({
        content: paginatedContent,
        size,
        totalElements,
        number: page,
        numberOfElements: paginatedContent.length,
        totalPages,
      })
    )
  }
)

export const getCustomerReferenceHandler = rest.get(
  `${API_URL}/api/platform/v1/customers/:customerReference`,
  async (req, res, ctx) => {
    const { customerReference } = req.params

    const customer = mockCustomers.find(c => c.reference === customerReference)
    if (customer) {
      return res(ctx.json(customer))
    }

    return res(
      ctx.status(404),
      ctx.json({
        message: 'Customer not found',
        status: 404,
      })
    )
  }
)

export default [getCustomersHandler, getCustomerReferenceHandler]

export const mockApplications: Application[] = [
  {
    id: 'app-001',
    externalReference: 'EXT-001',
    status: 'APPROVED',
    onboardingType: 'EMBEDDED',
    customerType: 'COMPANY',
    onboardingApplication: { documentsIntakeEmail: 'docs@example.com' },
    users: [
      {
        id: 'user-001',
        email: 'user@example.com',
        link: { link: 'https://example.com', linkType: 'ONBOARDING', linkExpiresAt: '2025-01-01' },
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
    ],
  },
  {
    id: 'app-002',
    externalReference: 'EXT-002',
    status: 'SUBMITTED',
    onboardingType: 'EMBEDDED',
    customerType: 'INDIVIDUAL',
    onboardingApplication: { documentsIntakeEmail: 'docs@example.com' },
    users: [],
  },
]

export const mockApplicationsItems: Application[] = [
  {
    id: 'app-001',
    externalReference: 'EXT-001',
    status: 'APPROVED',
    onboardingType: 'EMBEDDED',
    customerType: 'COMPANY',
    onboardingApplication: { documentsIntakeEmail: 'docs@example.com' },
    users: [
      {
        id: 'user-001',
        email: 'user@example.com',
        link: { link: 'https://example.com', linkType: 'ONBOARDING', linkExpiresAt: '2025-01-01' },
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
      },
    ],
  },
  {
    id: 'app-002',
    externalReference: 'EXT-002',
    status: 'SUBMITTED',
    onboardingType: 'EMBEDDED',
    customerType: 'INDIVIDUAL',
    onboardingApplication: { documentsIntakeEmail: 'docs@example.com' },
    users: [],
  },
  {
    id: 'app-003',
    externalReference: 'EXT-003',
    status: 'IN_REVIEW',
    onboardingType: 'EMBEDDED',
    customerType: 'COMPANY',
    onboardingApplication: { documentsIntakeEmail: 'docs@example.com' },
    users: [],
  },
  {
    id: 'app-004',
    externalReference: 'EXT-004',
    status: 'REJECTED',
    onboardingType: 'EMBEDDED',
    customerType: 'INDIVIDUAL',
    onboardingApplication: { documentsIntakeEmail: 'docs@example.com' },
    users: [],
  },
  {
    id: 'app-005',
    externalReference: '',
    status: 'NOT_STARTED',
    onboardingType: 'EMBEDDED',
    customerType: 'COMPANY',
    onboardingApplication: { documentsIntakeEmail: 'docs@example.com' },
    users: [],
  },
]
